module.exports = __webpack_public_path__ + "static/media/back (1).1d2127cc.svg";